module.exports = __webpack_public_path__ + "static/media/mod_risev2_4.2110cc68.jpg";